import styled from "styled-components";

export const CollapsibleWrapper = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #f2f0f0;
    padding-right: 8px;
    padding-left: 10px;
  }
  .header-active{
    background-color: #ff6801!important;
    .schedule-header{
      div{
        color: #f2f0f0 !important;
      }
    }
    svg{
      path{
        fill: #f2f0f0 !important;
      }
    }
  }
  .collapsible-arrow {
    transition: all 0.25s ease-in-out;
    min-width: 24px;
  }
  .is-active {
    transform: rotate(180deg);
  }
  .content {
    overflow: hidden;
    transition: all 0.15s ease-in-out;
  }
  .header-active {
    background-color: rgba(34, 24, 24, 0.1);
  }
  
  .content,
  .content_body {
    display: flex;
    align-items: flex-start;
  }
`;
